import { atom } from 'recoil';
import { recoilPersist } from 'recoil-persist';

const { persistAtom } = recoilPersist();

export const competencesAtom = atom({ key: 'competencesAtom', default: [], effects_UNSTABLE: [persistAtom] });
